import { createLogPrefix, type LogTarget } from '@amazon/vinyl-util'
import { createErrorHandler } from '@/errorHandler'

export interface Context {
    readonly target: LogTarget
    readonly errorHandler: (error: Error) => void
}

/**
 * Creates a logging target and error handler with the given name.
 * @param name
 */
export function ctx(name: string): Context {
    const target: LogTarget = { logPrefix: createLogPrefix(name) }
    return {
        target,
        errorHandler: createErrorHandler(target),
    }
}
